export const shadowElevateSubtle = '0 8px 12px -4px rgba(0, 0, 0, 0.05)'
export const shadowElevateMedium = '0 8px 12px -4px rgba(0, 0, 0, 0.1)'
export const shadowElevateStrong = '0 2px 8px -6px rgba(0, 0, 0, 0.6)'
export const shadowRaiseSubtle = '0 3px 12px 0 rgba(0, 0, 0, 0.1)'
export const shadowRaiseMedium = '0 6px 24px 0 rgba(0, 0, 0, 0.1)'
